<template>
  <div
    v-if="isVisible"
    class="refonte-page-alert"
    v-bind:class="props.class">
    <h1 v-if="props.title">
      {{ props.title }}
    </h1>
    <div
      v-if="!!slots['default']"
      class="alert"
      v-bind:class="[props.alert_type ? `alert-${props.alert_type}` : '']">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, useSlots } from 'vue';

  const props = withDefaults(
    defineProps<{
      title?: string;
      description?: string;
      description_in_card?: boolean;
      class?: string;
      alert_type?: 'success' | 'warning' | 'error' | 'info' | 'news';
      start_date?: string;
      end_date?: string;
    }>(),
    {
      description_in_card: false,
      class: '',
      alert_type: 'info'
    }
  );

  const slots = useSlots();
  const isVisible = computed(() => {
    const now = new Date();
    const start = props.start_date ? new Date(props.start_date) : null;
    const end = props.end_date ? new Date(props.end_date) : null;

    if (start && now < start) return false;
    if (end && now > end) return false;
    return true;
  });
</script>

<style lang="scss" scoped>
  .refonte-page-alert {
    @apply flex flex-col items-start self-stretch text-refonte-black;
    gap: 8px;
    margin-bottom: 24px;

    h1 {
      padding: 0 12px;
    }

    .alert {
      width: 100%;
      padding: 12px 16px;
      border-radius: 8px;
      font-size: 14px;
      line-height: 1.4;

      &.alert-success {
        background-color: #d1fae5;
        color: #065f46;
        border: 1px solid #10b981;
      }
      &.alert-warning {
        background-color: #fef3c7;
        color: #92400e;
        border: 1px solid #f59e0b;
      }
      &.alert-error {
        background-color: #fee2e2;
        color: #991b1b;
        border: 1px solid #ef4444;
      }
      &.alert-info {
        background-color: #e0f2fe;
        color: #075985;
        border: 1px solid #3b82f6;
      }
      &.alert-news {
        background-color: #fff7ed;
        color: #1f2937;
        border-left: 6px solid #f97316;
        padding: 16px 20px;
        border-radius: 10px;

        :deep(.alert-link) {
          color: #2563eb;
          text-decoration: underline;
          font-weight: 500;
        }

        :deep(.alert-link:hover) {
          color: #1d4ed8;
        }
      }
    }
  }
</style>
